import React from "react";
import { PageHeader } from "antd";
import { Account } from "../components";

import './Header.scss';

export default function Header(props) {
  const {
    address,
    userSigner,
    web3Modal,
    loadWeb3Modal,
    logoutOfWeb3Modal,
    blockExplorer,
  } = props;

  return (
    <div className="Header">
      <PageHeader
        title={
          <div style={{
            textAlign: 'left',
          }}>
            {/*<div><a className="home-link" href="/" rel="noopener noreferrer">Blue Checkmark</a></div>*/}
            <div>Blue Checkmark</div>
            <div style={{
              fontSize: '12px',
              fontWeight: 'normal',
              lineHeight: '1.2em',
            }}>By <a href="https://sylphdapps.com" target="_blank" rel="noreferrer">Sylph Dapps</a></div>
          </div>
        }
        extra={[
          <div className="extras" key="extras">
            <Account
              address={address}
              userSigner={userSigner}
              web3Modal={web3Modal}
              loadWeb3Modal={loadWeb3Modal}
              logoutOfWeb3Modal={logoutOfWeb3Modal}
              blockExplorer={blockExplorer}
            />
          </div>
        ]}
      />
    </div>
  );
}